export const createQuizQuestion = (payload?: any) => ({
    type: "@saga/CREATE_QUIZ_QUESTION",
    payload
});

